import baseApi from './base';

// 角色管理-获取角色列表
const fetchRoleList = params =>
  baseApi.request({
    method: 'get',
    url: '/role',
    params
  });

// 角色管理-新增角色
const createRoleList = data =>
  baseApi.request({
    method: 'post',
    url: '/role',
    data
});

// 角色管理-修改角色
const uptateRoleList = (id, data) =>
  baseApi.request({
    method: 'PATCH',
    url: `/role/${id}`,
    data
});

// 角色管理-删除角色
const deleteRoleList = (id, data) =>
  baseApi.request({
    method: 'delete',
    url: `/role/${id}`,
    data
});

// 角色管理-获取角色详情
const getDetail = id =>
  baseApi.request({
    method: 'get',
    url: `/role/${id}`,
});

// 角色管理-获取所有角色
const fetchRoleAll = () =>
  baseApi.request({
    method: 'get',
    url: '/role/all',
  });

// 角色管理-获取所有角色
const getResourcesList = () =>
baseApi.request({
  method: 'get',
  url: '/resources',
});
export {
  fetchRoleList,
  createRoleList,
  uptateRoleList,
  deleteRoleList,
  getDetail,
  fetchRoleAll,
  getResourcesList
};



// WEBPACK FOOTER //
// ./src/api/role.js